<script setup lang="ts">
definePageMeta({
  layout: false,
  auth: false,
})

// Its URL in Czech, German and Polish (constants/localizedRoutes.ts).
false && /*#__PURE__*/ defineI18nRoute({ paths: { cs: '/ats-kontrola-zivotopisu', de: '/ats-check-lebenslauf', pl: '/sprawdzanie-cv-ats' } })
</script>

<template>
  <MarketingFeaturePage seo-key="atsCheck" path="/ats-check">
      <AtsCvChecker />
      <LazyHomepageAtsCheckSection />
  </MarketingFeaturePage>
</template>
